import { Col, Container, Row } from "react-bootstrap";
import "../css/textContentBio.css";
import { useContext, useEffect, useState } from "react";
import ApiService from "../../../../services/api";
import parse from "html-react-parser";
import { AuthContext } from "../../../../services/auth";

const TextContentBio = () => {
  const { isEnglish } = useContext(AuthContext);
  const [category, setCategory] = useState({});
  const [textBio, setAbout] = useState({});
  const [Loading, setLoading] = useState(true);
  let change_color = 0;

  const fetchImg = async () => {
    const textBio = await ApiService.getContentTextBioS();
    const Category = await ApiService.getCategories();
    setCategory(Category.filter((select) => select.type === "bio"));
    setAbout(textBio);
    setLoading(false);
  };

  useEffect(() => {
    fetchImg();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="p-0 mt-5">
      <Container className="p-0">
        <Row className="w-100 d-flex justify-content-between align-items-center m-0">
          <Col className="col-12 m-0 px-2">
            {category.map((category) => {
              if (change_color === 0) {
                change_color++;
              } else {
                change_color = 0;
              }
              return (
                <Container
                  fluid
                  className={`d-flex justify-content-center align-items-center`}
                  key={category.id}
                >
                  <Row>
                    {textBio
                      .filter((nav) => nav.category === category.name)
                      .map((bio) => {
                        return (
                          <Col
                            lg="12"
                            className="py-4"
                            key={bio.id}
                          >
                            <h3 className={"section-title text-center"}>
                              {isEnglish ? bio.title_eng : bio.title}
                            </h3>
                            {bio.title && (
                              <div className="border-custom mt-3 mb-5"></div>
                            )}
                            {bio.text && (
                              <h5 className="section-text text-center mb-5">
                                {isEnglish
                                  ? parse(bio.text_eng)
                                  : parse(bio.text)}
                              </h5>
                            )}
                          </Col>
                        );
                      })}
                  </Row>
                </Container>
              );
            })}
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
export default TextContentBio;
